import { GROLOG_BASE_URL, GROLOG_ORDER_URL } from "../constant/apiConstant";

/// Company Profile
export const API_COMPANY_PROFILE = `company-profile`;

// DELIVERY ASSOCIATE
export const API_DELIVERY_ASSOCIATE = `delivery-associate`

// DEPOT
export const DROPDOWN_DEPOT = `${GROLOG_BASE_URL}/depot-configuration/dropdown`;
export const LIST_DEPOT = `${GROLOG_BASE_URL}/depot-configuration`;
export const LIST_DEPOT_INITIATE = `${GROLOG_BASE_URL}/depot-configuration/initiate`;

// EXPORT
export const EXPORT_ORDER_INVOICE = `${GROLOG_ORDER_URL}/export/report-invoice/pdf`;

// REPORT ORDER
export const LIST_ORDER_REPORT = `${GROLOG_ORDER_URL}/report/order`;
export const EXPORT_ORDER_REPORT = `${GROLOG_ORDER_URL}/report/order/export/pdf`;

// REPORT DELIVERY ASSOCIATE
export const INITIATE_REPORT_DELIVERY_ASSOCIATE = `${GROLOG_ORDER_URL}/report/order`;
export const LIST_DELIVERY_ASSOCIATE_REPORT = `${GROLOG_ORDER_URL}/report/delivery-associate`;
export const EXPORT_DELIVERY_ASSOCIATE_REPORT = `${GROLOG_ORDER_URL}/report/delivery-associate/export/pdf`;

// REPORT TRIP
export const INITIATE_DROPDOWN_REPORT_TRIP = `${GROLOG_ORDER_URL}/all-trip/dropdown-report/initiate`;
export const DROPDOWN_REPORT_TRIP = `${GROLOG_ORDER_URL}/all-trip/dropdown-report`;
export const LIST_TRIP_REPORT = `${GROLOG_ORDER_URL}/report/trip-report`;
export const EXPORT_TRIP_REPORT = `${GROLOG_ORDER_URL}/export/trip-report/pdf`;